import { ArrowDownCircle, ArrowUpCircle, TrendingUp, TrendingDown } from 'react-feather'
import { Card, CardBody, Col, Row, Spinner } from 'reactstrap'
import { newFormatThousandSeparator } from 'utils/formatNumber'

const SummaryCards = ({ summaryData, isLoading }) => {
  const data = summaryData?.data || summaryData
  const purchase = data?.purchase
  const sales = data?.sales
  const difference = data?.difference

  const diffValue = difference?.totalAfterVAT ?? difference?.totalValue ?? 0

  const cards = [
    {
      title: 'Total Pembelian',
      value: purchase?.totalAfterVAT ?? purchase?.totalValue ?? 0,
      count: purchase?.transactionCount ?? null,
      prevValue: purchase?.previousPeriod?.totalAfterVAT,
      prevCount: purchase?.previousPeriod?.transactionCount,
      icon: <ArrowDownCircle size={24} />,
      bgColor: '#FFFBFA',
      iconColor: '#D92D20',
      borderColor: '#FECDCA',
      textColor: '#D92D20',
      testId: 'summary-card-purchase',
    },
    {
      title: 'Total Penjualan',
      value: sales?.totalAfterVAT ?? sales?.totalValue ?? 0,
      count: sales?.transactionCount ?? null,
      prevValue: sales?.previousPeriod?.totalAfterVAT,
      prevCount: sales?.previousPeriod?.transactionCount,
      icon: <ArrowUpCircle size={24} />,
      bgColor: '#F6FEF9',
      iconColor: '#039855',
      borderColor: '#A6F4C5',
      textColor: '#039855',
      testId: 'summary-card-sales',
    },
    {
      title: 'Selisih (Margin)',
      value: diffValue,
      count: difference?.transactionCount != null
        ? Math.abs(difference.transactionCount)
        : null,
      countLabel: 'selisih transaksi',
      prevValue: difference?.previousPeriod?.totalAfterVAT,
      icon: diffValue >= 0 ? <TrendingUp size={24} /> : <TrendingDown size={24} />,
      bgColor: diffValue >= 0 ? '#F3FEFF' : '#FFFCF5',
      iconColor: diffValue >= 0 ? '#027A48' : '#B42318',
      borderColor: diffValue >= 0 ? '#A6F4C5' : '#FECDCA',
      textColor: diffValue >= 0 ? '#027A48' : '#B42318',
      testId: 'summary-card-margin',
    },
  ]

  const getChangePercent = (current, previous) => {
    if (previous == null || previous === 0) return null
    return ((current - previous) / Math.abs(previous)) * 100
  }

  return (
    <Row className="mb-3">
      {cards.map((card, idx) => {
        const changePercent = getChangePercent(card.value, card.prevValue)

        return (
          <Col xs={12} md={4} key={idx} className="mb-2 mb-md-0">
            <Card
              data-testid={card.testId}
              style={{
                border: `1px solid ${card.borderColor}`,
                borderRadius: '12px',
                background: card.bgColor,
                boxShadow: 'none',
                height: '100%',
              }}
            >
              <CardBody className="d-flex align-items-center gap-3 py-3">
                <div
                  style={{
                    width: 48,
                    height: 48,
                    borderRadius: '12px',
                    backgroundColor: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: card.iconColor,
                    border: `1px solid ${card.borderColor}`,
                    flexShrink: 0,
                  }}
                >
                  {card.icon}
                </div>
                <div className="d-flex flex-column" style={{ minWidth: 0 }}>
                  <span
                    style={{
                      fontSize: '0.8rem',
                      color: '#667085',
                      fontWeight: 500,
                      marginBottom: 2,
                    }}
                  >
                    {card.title}
                  </span>
                  {isLoading ? (
                    <Spinner size="sm" color="secondary" />
                  ) : (
                    <>
                      <span
                        style={{
                          fontSize: '1.25rem',
                          fontWeight: 700,
                          color: card.textColor,
                          lineHeight: 1.2,
                        }}
                      >
                        {card.value < 0 ? '-' : ''}Rp
                        {newFormatThousandSeparator(Math.abs(card.value), 0)}
                      </span>
                      <div className="d-flex align-items-center gap-2 mt-1 flex-wrap">
                        {card.count !== null && card.count !== undefined && (
                          <span
                            style={{
                              fontSize: '0.75rem',
                              color: '#98A2B3',
                            }}
                          >
                            {card.count} {card.countLabel || 'transaksi'}
                          </span>
                        )}
                        {changePercent !== null && (
                          <span
                            style={{
                              fontSize: '0.7rem',
                              color: changePercent >= 0 ? '#027A48' : '#B42318',
                              fontWeight: 600,
                              background: changePercent >= 0 ? '#D1FADF' : '#FEE4E2',
                              padding: '1px 6px',
                              borderRadius: '10px',
                            }}
                          >
                            {changePercent >= 0 ? '↑' : '↓'}
                            {newFormatThousandSeparator(Math.abs(changePercent), 1)}%
                          </span>
                        )}
                        {card.prevValue != null && (
                          <span
                            style={{
                              fontSize: '0.7rem',
                              color: '#98A2B3',
                            }}
                          >
                            vs periode sebelumnya
                          </span>
                        )}
                      </div>
                    </>
                  )}
                </div>
              </CardBody>
            </Card>
          </Col>
        )
      })}
    </Row>
  )
}

export default SummaryCards
